import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
 
  constructor( private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public auth: AuthService) { }
id;
vendorApp;
public customer:boolean;

ionViewWillEnter(){
  this.vendorApp = sessionStorage.getItem('vendorApp')
}
  
  vendorProfile(){
    this.id = localStorage.getItem('currentUserId')
    this.router.navigate(['vendorProfile/',this.id])
  }

   
    logout() {
      let post ={
         "userId": localStorage.getItem('currentUserId')       }
          this.auth.LogOut(post).subscribe(res => {
          localStorage.clear();
          sessionStorage.clear();  
          this.handler.res('Thank You Visit Again !!')
          this.router.navigate(['/vendor-register']);
        }, err => {
          this.handler.err(err);
          localStorage.clear(); 
          sessionStorage.clear();
          this.router.navigate(['/vendor-register']);
        })       
 
  }


  ngDoCheck(): void {
    this.vendorApp = sessionStorage.getItem('vendorApp');
   
  }


}
